module.exports = __webpack_public_path__ + "img/ufcw-cf-white.96097113.svg";